export const BY_SEGMENTS = 'By Segments';
export const BY_AUDIENCES = 'By Audiences';
